export default "__VITE_ASSET__D7QoMpjj__"